import { generateId } from '@repo/shared/uuid/uuid'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@repo/ui/card'
import { useScrollToEnd, useT } from '@repo/ui/hooks'
import { ScrollArea } from '@repo/ui/scrollArea'
import { sortByKey } from '@repo/ui/utils'
import { useEffect, useRef } from 'react'

import { Chat } from '@/components/admin/insights/chat/Chat'
import { ChatInput } from '@/components/admin/insights/chat/ChatInput'
import { RadarLoader } from '@/components/assistant/RadarLoader'
import { adminStoreActions } from '@/store/actions'
import { useStoreDispatch, useStoreState } from '@/store/hooks'

export function InsightsChatRoute() {
  const { t } = useT({ keyPrefix: 'admin.insights.chat' })
  const dispatch = useStoreDispatch()

  useEffect(() => {
    dispatch(adminStoreActions.initAnalyticsChat({ generationId: generateId() }))
  }, [])

  const isThinking = useStoreState((state) => state.assistant.isThinking)

  const feed = useStoreState((state) => state.assistant.feed)
  const items = feed.filter(
    (item) =>
      item.type === 'message' ||
      item.type === 'insightDisplay' ||
      (item.type === 'cta' && item.cta === 'beneficiaryInsights'),
  )
  const sortedItems = [...items].sort(sortByKey('sentAt'))

  const chatBottomRef = useRef<HTMLDivElement>(null)
  const scrollToFeedEnd = useScrollToEnd(chatBottomRef, 'smooth')
  useEffect(() => {
    // Delay slightly to allow DOM update before scrolling
    const timer = setTimeout(() => scrollToFeedEnd(), 100)
    return () => clearTimeout(timer)
  }, [sortedItems.length, scrollToFeedEnd])

  return (
    <Card className="flex flex-1 flex-col overflow-hidden bg-opacity-20">
      <CardHeader>
        <CardTitle>{t('title')}</CardTitle>
        <CardDescription>{t('description')}</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-1 flex-col gap-4">
        <ScrollArea className="border-primary-50 max-h-[calc(100vh-325px)] flex-1 rounded-lg border bg-white/50">
          <div className="flex flex-1 flex-col gap-4 p-4">
            <Chat items={sortedItems} isThinking={isThinking} />
          </div>
          <div className="h-1" id="chat-end" ref={chatBottomRef} />
        </ScrollArea>
        {isThinking && <RadarLoader />}
        <ChatInput isDisabled={false} />
      </CardContent>
    </Card>
  )
}
